module.exports = __webpack_public_path__ + "static/9_whatsapp_marketing-e88bec1e87189aa4c1a924f8cba91f06.webp";